module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.currentUser.isAdmin || _vm.currentUser.id === _vm.user.id) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : [(_vm.loadingRoles) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем роли..."
    }
  }) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n                Роли пользователя\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row mb-1"
  }, _vm._l((_vm.roles), function(role) {
    return _c('div', {
      staticClass: "col-12 col-md-6 col-lg-3"
    }, [_c('div', {
      staticClass: "row  mb-2"
    }, [_c('div', {
      staticClass: "col-8"
    }, [_vm._v(_vm._s(role.description))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(_vm.rolesChanges.indexOf(role.id) !== -1) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": false
      }
    }) : _c('label', {
      staticClass: "switch switch-lg switch-3d switch-primary"
    }, [_c('input', {
      staticClass: "switch-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": _vm.user.hasRole(role.name),
        "checked": _vm.user.hasRole(role.name)
      },
      on: {
        "change": function($event) {
          _vm.updateUserRole(_vm.user.hasRole(role.name), role.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-label"
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-handle"
    })])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row  mb-2"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("\n                        Персональные права доступа для пользователя "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-warning small"
  }, [_vm._v("При активации все доступные роли пользователя будут деактивированы. Необходимо будет вручную настроить права доступа")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.rolesChanges.indexOf('personal') !== -1) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : (_vm.user.roles.length === 0) ? _c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.auto",
      modifiers: {
        "hover": true,
        "auto": true
      }
    }],
    staticClass: "switch switch-lg switch-3d switch-primary",
    attrs: {
      "title": "Для отключения персональных прав доступа активируйте одну из ролей"
    }
  }, [_c('input', {
    staticClass: "switch-input disabled",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "value": _vm.user.roles.length === 0,
      "checked": _vm.user.roles.length === 0
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]) : _c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.user.roles.length === 0,
      "checked": _vm.user.roles.length === 0
    },
    on: {
      "change": function($event) {
        _vm.clearUserRole()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])], 1)])])]), _vm._v(" "), (_vm.loadingPermissions) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем права доступа..."
    }
  }) : _c('div', [(_vm.user.roles.length !== 0) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                Права доступа отображаются из совокупности ролей, вы можете активировать персональные права доступа для этого пользователя, если выставите соответсующий переключатель в разделе роли\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getPermissionsGroups()), function(group) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n                    " + _vm._s(_vm.getPermissionsGroupName(group)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((_vm.getPermissionsByGroupName(group)), function(permission) {
      return _c('div', {
        staticClass: "col-12 col-md-6 col-lg-3"
      }, [_c('div', {
        staticClass: "row  mb-2"
      }, [_c('div', {
        staticClass: "col-8"
      }, [_vm._v(_vm._s(permission.description))]), _vm._v(" "), _c('div', {
        staticClass: "col-4"
      }, [(_vm.permissionChanges.indexOf(permission.id) !== -1) ? _c('loading', {
        attrs: {
          "size": 2,
          "message": false
        }
      }) : (_vm.user.roles.length === 0) ? _c('label', {
        staticClass: "switch switch-lg switch-3d switch-primary"
      }, [_c('input', {
        staticClass: "switch-input",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": _vm.user.hasPermission(permission.name),
          "checked": _vm.user.hasPermission(permission.name)
        },
        on: {
          "change": function($event) {
            _vm.updateUserPermission(_vm.user.hasPermission(permission.name), permission.id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (_vm.user.hasPermission(permission.name)) ? _c('small', [_vm._v("разрешено")]) : _c('small', [_vm._v("запрещено")])]) : (_vm.currentUser.hasPermission(permission.name)) ? _c('label', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.auto",
          modifiers: {
            "hover": true,
            "auto": true
          }
        }],
        staticClass: "switch switch-lg switch-3d switch-primary",
        attrs: {
          "title": "Для активации отдельных разрешений переключите использование идивидуальных прав доступа в разделе роли"
        }
      }, [_c('input', {
        staticClass: "switch-input disabled",
        attrs: {
          "type": "checkbox",
          "disabled": ""
        },
        domProps: {
          "value": _vm.user.hasPermission(permission.name),
          "checked": _vm.user.hasPermission(permission.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (_vm.user.hasPermission(permission.name)) ? _c('small', [_vm._v("разрешено")]) : _c('small', [_vm._v("запрещено")])]) : _c('label', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.auto",
          modifiers: {
            "hover": true,
            "auto": true
          }
        }],
        staticClass: "switch switch-lg switch-3d switch-primary",
        attrs: {
          "title": "Вы не можете разрешить данное действие пользователю, т.к. сами не имеете доступа к данным правам"
        }
      }, [_c('input', {
        staticClass: "switch-input disabled",
        attrs: {
          "type": "checkbox",
          "disabled": ""
        },
        domProps: {
          "value": _vm.user.hasPermission(permission.name),
          "checked": _vm.user.hasPermission(permission.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (_vm.user.hasPermission(permission.name)) ? _c('small', [_vm._v("разрешено")]) : _c('small', [_vm._v("запрещено")])])], 1)])])
    }))])])
  })], 2)]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Только администраторы могут изменять роли и права доступа пользовалей. Если вы считаете, что у вас должно быть больше прав, пожалуйста напишите на почту "), _c('a', {
    attrs: {
      "href": "mailto:anton@alarm.ru"
    }
  }, [_vm._v("anton@alarm.ru")]), _vm._v(" с просьбой предоставить доступ.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            В дальнейшем руководители в компаниях и техцентрах смогут управлять пользователями и их правами в рамках своего техцентра. Данный функционал пока в разработке, по всем вопросам просьба писать на "), _c('a', {
    attrs: {
      "href": "mailto:anton@alarm.ru"
    }
  }, [_vm._v("anton@alarm.ru")]), _vm._v(".\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-c3a99eba"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/Permissions.vue
// module id = 1069
// module chunks = 1